import React from "react";
import { Link } from "react-router-dom";
import "../assets/styles/footer.scss";
import iconInstagram from "../assets/icons/instagram-light.svg";
import iconLinkedin from "../assets/icons/linkedin-light.svg";
import iconPhone from "../assets/icons/phone-light.svg";
import iconWpp from "../assets/icons/whatsapp-light.svg";
import iconEmail from "../assets/icons/email-light.svg";
import iconLocation from "../assets/icons/location-light.png";
import iconFacebook from "../assets/icons/facebook-light.svg";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container-footer">
        <div className="row">
          <div className="footer-col">
            <h4>Contatos</h4>
            <div className="social-links">
              <Link
                target="_blank"
                to={{ pathname: "https://www.facebook.com/alucomcomputadores" }}
              >
                <img
                  src={iconFacebook}
                  alt="Icone Facebook"
                  className="icon-social"
                />
              </Link>
              <Link
                target="_blank"
                to={{ pathname: "https://www.instagram.com/alucomti/" }}
              >
                <img
                  src={iconInstagram}
                  alt="Icone Instagram"
                  className="icon-social"
                />
              </Link>
              <Link>
                <img
                  src={iconLinkedin}
                  alt="Icone Linkedin"
                  className="icon-social"
                />
              </Link>
              <Link
                target="_blank"
                to={{
                  pathname: "whatsapp://send?phone=+558598814-6081",
                }}
              >
                <img
                  src={iconWpp}
                  alt="Icone WhatsApp"
                  className="icon-social"
                />
              </Link>
              <Link target="_blank" to={{ pathname: "tel:+558593262-3191" }}>
                <img
                  src={iconPhone}
                  alt="Icone WhatsApp"
                  className="icon-social"
                />
              </Link>
              <Link
                target="_blank"
                to={{
                  pathname: "mailto:comercial@alucom.com.br",
                }}
              >
                <img
                  src={iconEmail}
                  alt="Icone E-mail"
                  className="icon-social"
                />
              </Link>
            </div>
            <div className="social-contacts">
              <Link
                target="_blank"
                to={{
                  pathname: "mailto:comercial@alucom.com.br",
                }}
              >
                <img
                  src={iconEmail}
                  alt="Icone Email"
                  className="icon-contacts"
                />
                comercial@alucom.com.br
              </Link>
              <Link target="_blank" to={{ pathname: "tel:+558593262-3191" }}>
                <img
                  src={iconPhone}
                  alt="Icone Telefone"
                  className="icon-contacts"
                />
                (85) 3262-3191 ou 0800 285 2165
              </Link>
            </div>
          </div>
          <div className="footer-col">
            <h4 className="title-categoria">Categorias</h4>
            <ul className="list-items">
              <li>Computadores</li>
              <li>Notebooks</li>
              <li>Retroprojetores</li>
              <li>Plotters</li>
              <li>Impressoras</li>
              <li>Impressoras de pulseiras</li>
              <li>hospitalares</li>
              <li>Switch</li>
              <li>Roteadores</li>
              <li>Tablets</li>
            </ul>
          </div>
          <div className="footer-col" style={{ textAlign: "left", display: "block" }}>
  
            {/* Canais de Denúncia */}
            <h4 style={{ fontSize: "1rem", marginBottom: "10px", display: "block" }}>
              Canais de denúncias
            </h4>
            <ul style={{  margin: "0 0 20px 0" }}>
              <li style={{ marginBottom: "5px" }}>
                <small style={{ color: "#ffff"}}>
                  Email: <a href="mailto:compliance@alucom.com.br">compliance@alucom.com.br</a>
                </small>
              </li>
              <li>
                <small style={{ color: "#ffff"}}>
                  Formulário de Denúncia: <a href="https://forms.gle/MBfFw7LixMqHWkXV8" target="_blank" rel="noreferrer">clique aqui</a>
                </small>
              </li>
            </ul>

            {/* Onde estamos */}
            <h4 style={{ fontSize: "1rem", marginBottom: "10px", display: "block" }}>
              Onde estamos?
            </h4>
            <ul>
              <li style={{ display: "flex", alignItems: "center", marginBottom: "5px", color: "#ffff" }}>
                <small>Rua Riachuelo, 40 - Papicu</small>
              </li>
              <li> 
                <small style={{ color: "#ffff"}}>60175-205 Fortaleza - CE</small>
              </li>
            </ul>
          </div>
        </div>
        <p>&copy; Alucom - 2026</p>
      </div>
    </footer>
  );
}

